module.exports = __webpack_public_path__ + "static/media/pitching.83f2f555.svg";